<template>

      <div class="rm" :ref="'rm_'+index">
        <div @click="selectRegistrationMethod(index)" class="rm-header row">
          <div class="row">
            <div class="col col-15 text-center"><input @input="selectRegistrationMethod(index)" class="input-radio" :id="'rm_'+index" name="rm" type="radio" :value="index"></div>
            <div class="col col-85">
              <label class="text-left" :for="'rm_'+index">
                <p class="mb-0 mt-0 lh-1-6"><strong>Email</strong></p>
                <p class="mb-0 mt-0 text-16 lh-1-6" >Enter Your Email to Stay Connected</p>
              </label>
            </div>
          </div>
        </div>
        <div class="rm-form p-30" v-if="selected==index">
          <div v-if="registration_method.registration_method_id==2">
            <div class="row mb-15">
              <input v-model="form.last_name" class="input-text rounded" type="text" placeholder="Last Name" />
            </div>
            <div class="row">
              <input v-model="form.room_number" class="input-text rounded" type="text" placeholder="Room Number" />
            </div>
          </div>
          <div v-if="registration_method.registration_method_id==3">
            <div class="row mb-15 p-rel">
              <input v-model="form.email_address" class="input-text rounded" type="text" placeholder="Email" />
            </div>
          </div>
          <div v-if="registration_method.registration_method_id==4" class="row p-rel">
            <input v-model="form.access_code" class="input-text rounded" type="text" placeholder="Access Code" />
          </div>
          <div class="pt-20 mb-15">
            <button @click="emitRegistrationMethodData()" class="btn rounded" type="button" style="background: rgb(94, 4, 77);
    color: rgb(255, 255, 255);">Continue</button>
          </div>
          <p class="text-center text-14 mb-0">By clicking continue you agree to the
            <span @click="selectTermsOfService(index)" class="text-link">Terms and Conditions</span>
          </p>
          <div class="terms-of-service text-left pt-20" v-if="selected_tos==index">
            <div v-html="registration_method.terms_of_service"></div>
            <div class="mt-30 text-center"><button class="btn-close" @click="selectTermsOfService(null)">CLOSE</button></div>
          </div>
        </div>
      </div> <!-- rm -->



</template>
<script>
import Axios from "axios";
export default {
  name: 'registration_method',
  props: ['index','selected','selected_tos','color_background_button','color_text_button','registration_method'],
  data(){
    return{
      // access_code: null,
      // access_code_valid: true,
      // access_code_error_text: 'Required',
      clicked: false,
      form: {
        access_code: '',
        room_number: '',
        first_name: '',
        last_name: '',
        email_address: '',
        consent: false
      },
      revinate: {
        list_token: "7d36c7a2-4e6f-410c-a6c7-7a4daa2d8e89",
        url: "https://contact-api.inguest.com/api/add-contacts-to-lists",
      },
    }
  },
  watch: {
    'selected':function(){
      this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
    }
  },
  mounted(){
    this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
  },
  methods: {
    // Generate the description that appears below the Registration Method name
    generateDescription:function(rm){
      if(rm.type!='rateplan') return null;

      // return the custom rate plan description if set on the rate plan
      if(rm.rate_plan_description) return rm.rate_plan_description

      var description = '';
      if (parseInt(rm.price)==0) {
        description += 'Connect';
      } else {
        description += '$' + rm.price;
      }

      description += ' for ';

      if(rm.duration>=1440){
        if(rm.duration % 1440 > 0){
          description += ' more than ';
        }
        var whole_days = Math.floor(rm.duration / 1440);
        description += whole_days + ' day'
        if(whole_days > 1){
          description += 's';
        }
      } else if(rm.duration>=60){
        if(rm.duration % 60 > 0){
          description += ' more than ';
        }
        var whole_hours = Math.floor(rm.duration / 60);
        description += whole_hours + ' hour'
        if(whole_hours > 1){
          description += 's';
        }
      } else {
        description += rm.duration + ' minute'
        if(rm.duration > 1){
          description += 's';
        }
      }

      description += ' with ';
      if(rm.additional_devices>0){
        //It needs to include the original device plu the additional devices
        description += 'up to ' + (rm.additional_devices+1) + ' devices';
      } else {
        description += '1 device';
      }
      if(rm.speed_upload && rm.speed_download){
        description += ' (' + rm.speed_upload + ' Up / ' + rm.speed_download + ' Down)';
      }
      return description;
    },

    // Manipulate and send registration method data back to parent
    emitRegistrationMethodData: async function(){
      // If no access code set, show required text
      if(this.registration_method.type=='accesscode' && !this.form.access_code){
        this.access_code_valid = false;
        return;
      }
      if(this.clicked){
        return;
      }
      this.clicked = true;


      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: null,
        email_address: null,
        last_name: null,
        room_number: null,
        access_code: null,
        marketing_consent: false
      };
      if(this.registration_method.registration_method_id=='1'){
        emitted.rateplan_id = this.registration_method.id;
      } else if(this.registration_method.registration_method_id=='2'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.last_name = this.form.last_name;
        emitted.room_number = this.form.room_number;
      } else if(this.registration_method.registration_method_id=='3'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.email_address = this.form.email_address;
      } else if(this.registration_method.registration_method_id=='4'){
        emitted.access_code = this.form.access_code;
      }

      if(this.form.consent){
        const revinate_data = {
          tokens: [this.revinate.list_token],
          contacts: [
            { email: this.form.email_address, first_name: this.form.first_name, last_name: this.form.last_name },
          ]
        };
        Axios.post(this.revinate.url,revinate_data).then(response => {
          this.$emit('emitRegistrationMethodData', emitted);
        }).catch( error => {
          this.$emit('error', 'Error registering with email address.');
        });
      } else {
        this.$emit('emitRegistrationMethodData', emitted);
      }
    },
  }
}
</script>
<style scoped>
</style>
